<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="540"
        :mask-closable="false"
        @on-close="FormReset('Forms')"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <FormItem label="父级路由" prop="parent_id">
                    <Select v-model="Forms.parent_id" clearable class="text-font-sm">
                        <Option v-for="item in parentList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="路由标题" prop="title">
                    <Input v-model="Forms.title" clearable placeholder="路由标题"  class="text-font-sm" />
                    <small class="text-999">路由显示的名称 如：订单管理</small>
                </FormItem>
                <FormItem label="路由名称" prop="name">
                    <Input v-model="Forms.name" clearable placeholder="Order"  class="text-font-sm" />
                    <small class="text-999">路由页面模块名称 如：Order</small>
                </FormItem>
                <FormItem label="访问地址" prop="url">
                    <Input v-model="Forms.url" clearable placeholder="/index/index"  class="text-font-sm" />
                    <small class="text-999">路由访问地址 如：/index/index</small>
                </FormItem>
                <FormItem label="文件路径" prop="file">
                    <Input v-model="Forms.file" clearable placeholder="/index/Index"  class="text-font-sm" />
                    <small class="text-999">路由文件路径 如：/index/Index</small>
                </FormItem>
                <FormItem label="路由排序" prop="sort">
                    <Input v-model="Forms.sort" clearable placeholder="默认为ID"  class="text-font-sm" />
                </FormItem>
                <FormItem label="路由图标" prop="icon">
                    <Input v-model="Forms.icon" clearable placeholder="md-home"  class="text-font-sm" />
                    <small class="text-999">路由显示图标 此处为字符图标</small>
                </FormItem>
                <FormItem label="任务状态" prop="status">
                    <RadioGroup v-model="Forms.status" type="button">
                        <Radio :label="1"><span class="text-primary">审核</span></Radio>
                        <Radio :label="2"><span class="text-danger">禁用</span></Radio>
                        <Radio :label="3"><span class="text-success">开启</span></Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getParentAuthList, saveAuth,getAuthDetail} from "@/apis/auth";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增路由',
            isBox : false,
            parentList : [],
            Forms : {
                id : '',
                parent_id : 0,
                title : '',
                name : '',
                file : '',
                url : '',
                icon : '',
                sort : '',
                status : 3
            },
            Rules : {
                title: [
                    { required: true, message: '请填写路由标题', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请填写路由名称', trigger: 'blur' }
                ],
                file: [
                    { required: true, message: '请填写路由文件路径', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请填写路由访问地址', trigger: 'blur' }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
    },
    methods: {
        /**
         功能：获取1级路由
         time: 2025-35-02 09:35:02
         **/
        GetParentRouter(){
            let that = this;
            getParentAuthList().then(e=>{
                that.parentList = e.data;
            })
        },
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(Id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getAuthDetail(Id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                }
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(ParentId){
            this.isBox = true;
            if(ParentId) this.Forms.parent_id = ParentId;
            this.GetParentRouter();
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(Id){
            this.isBox = true;
            this.GetParentRouter();
            this.title = "编辑路由";
            if(Id) this.GetDetail(Id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveAuth(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.$refs['Forms'].resetFields();
            this.title = "新增路由";
            this.Forms.id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
